import {
  Avatar,
  Box,
  Chip,
  CircularProgress,
  Pagination,
  Paper,
  Typography,
} from "@mui/material";
import axios from "axios";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Title from "../components/PageTitle";
import apiService from "../Services/api.service";
import { setUnreadCount } from "../store/rootReducer";

import { useDispatch } from "react-redux";
const Tags = () => {
  const [loading, setLoading] = useState(true);
  const [notifications, setNotifications] = useState([]);
  const [error, setError] = useState("");
  const token = localStorage.getItem("token");
  const [page, setPage] = useState(1);
  const dispatch = useDispatch();
  const [totalPages, setTotalPages] = useState(1);
  const limit = 10;

  const navigate = useNavigate();

  const fetchNotifications = async (pageNumber = 1) => {
    try {
      setLoading(true);

      const res = await axios.get(
        `${process.env.REACT_APP_API_HOST_URL}/ops/v1/tags?page=${pageNumber}&limit=${limit}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      setNotifications(res.data?.data || []);
      setTotalPages(res.data?.pagination?.totalPages || 1);
    } catch (err) {
      console.error(err);
      setError("Failed to load tags");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchNotifications(page);
  }, [page]);

  const handleRedirect = (url) => {
    navigate(url); // HashRouter safe
  };
  const fetchUnreadCount = async () => {
    try {
      const res = await apiService.getUnreadCount(token);

      dispatch(setUnreadCount(res));
    } catch (error) {
      console.error("Unread count error:", error);
    }
  };
  const markAsRead = async (notificationId) => {
    try {
      const token = localStorage.getItem("token");

      await axios.patch(
        `${process.env.REACT_APP_API_HOST_URL}/ops/v1/tags/${notificationId}/read`,
        {},
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      setNotifications((prev) =>
        prev.map((n) => (n._id === notificationId ? { ...n, isRead: true } : n))
      );
      fetchUnreadCount();
    } catch (err) {
      console.error("Failed to mark notification as read", err);
    }
  };

  return (
    <Paper sx={{ p: 3, minHeight: "95vh" }}>
      <Title text="Mentions & Tags" />

      {/* Loading */}
      {loading && (
        <Box display="flex" justifyContent="center" mt={4}>
          <CircularProgress />
        </Box>
      )}

      {/* Error */}
      {!loading && error && (
        <Typography color="error" mt={2}>
          {error}
        </Typography>
      )}

      {/* Empty */}
      {!loading && !error && notifications.length === 0 && (
        <Typography color="text.secondary" mt={2}>
          No tags yet 🎉
        </Typography>
      )}

      {/* Notifications List */}
      {!loading &&
        notifications.map((item) => (
          <Box
            key={item._id}
            onClick={async () => {
              if (!item.isRead) {
                await markAsRead(item._id);
              }
              handleRedirect(item.redirectUrl);
            }}
            sx={{
              display: "flex",
              alignItems: "flex-start",
              gap: 2,
              mt: 2,
              p: 2,
              borderRadius: 2,
              cursor: "pointer",

              border: "1px solid #e0e0e0",
              transition: "0.2s",
            }}
          >
            <Avatar
              sx={{
                bgcolor: (theme) =>
                  theme.palette.mode === "dark"
                    ? theme.palette.primary.dark
                    : theme.palette.primary.main,
              }}
            >
              {item.sender?.name?.[0]?.toUpperCase()}
            </Avatar>

            <Box flex={1}>
              <Box
                display="flex"
                justifyContent="space-between"
                alignItems="center"
              >
                <Typography fontWeight={600}>{item.sender?.name}</Typography>

                {!item.isRead && (
                  <Chip label="Unread" size="small" color="primary" />
                )}
              </Box>

              <Typography sx={{ mt: 0.5 }}>{item.message}</Typography>

              <Typography
                variant="caption"
                color="text.secondary"
                sx={{ mt: 0.5, display: "block" }}
              >
                {new Date(item.createdAt).toLocaleString()}
              </Typography>
            </Box>
          </Box>
        ))}

      {/* Pagination */}
      {!loading && totalPages > 1 && (
        <Box display="flex" justifyContent="center" mt={4}>
          <Pagination
            count={totalPages}
            page={page}
            onChange={(e, value) => setPage(value)}
            color="primary"
          />
        </Box>
      )}
    </Paper>
  );
};

export default Tags;
